module.exports = __webpack_public_path__ + "static/gavilanwork6-8ad89d5451d9cf3ebac95c996437fa04.jpg";